// Geteilter, gecachter Loader für GET /rbac/teams-lite (M3). Dedupt die mehreren
// unabhängigen Aufrufer (Kontakte-/Vorgänge-Tabellen, Meine-Kunden-Karte, Vorgang-
// Anlegen, Legacy-Kontakte) via swrCache (In-Flight + 5-min-TTL) auf effektiv EINEN
// Netz-Request. Rückgabe: das ROHE teams-lite-Array — Konsumenten mappen selbst,
// da manche zusätzliche Felder brauchen (z. B. teamLeaderId in VorgangCreate).
import { cached } from "./swrCache";
import { apiFetch } from "./apiFetch";

export async function fetchTeamsLite(): Promise<any[]> {
  return cached(
    "rbac.teams-lite",
    async () => {
      const res = await apiFetch<any[]>("rbac/teams-lite");
      return Array.isArray(res.data) ? res.data : [];
    },
    { ttlMs: 5 * 60_000 },
  );
}
